import React from 'react'
import LoadingPlaceholderBlock from "../../../../../components/common/LoadingPlaceholderBlock";
import styles from "../Utilities/Styles.module.css"

const MetricsMessageListLoader = () => {
    return (
        <div>
            <div className={`${styles['borderGray']} message-list-container`}>
                <div className="margin-right-15">
                    <LoadingPlaceholderBlock width={'403px'} height={'38px'} borderRadius={'3px'}
                                             backgroundColor={'rgb(239, 234, 229)'}/>
                </div>
                <div className="margin-right-15">
                    <LoadingPlaceholderBlock height={'18px'} width={'80px'} borderRadius={'3px'}
                                             backgroundColor={'rgb(239, 234, 229)'}/>
                </div>
            </div>
            <div className={`${styles['borderGray']} message-list-container`}>
                <div className="margin-right-15">
                    <LoadingPlaceholderBlock width={'403px'} height={'38px'} borderRadius={'3px'}
                                             backgroundColor={'rgb(239, 234, 229)'}/>
                </div>
                <div className="margin-right-15">
                    <LoadingPlaceholderBlock height={'18px'} width={'80px'} borderRadius={'3px'}
                                             backgroundColor={'rgb(239, 234, 229)'}/>
                </div>
            </div>
            <div className={`${styles['borderGray']} message-list-container`}>
                <div className="margin-right-15">
                    <LoadingPlaceholderBlock width={'403px'} height={'38px'} borderRadius={'3px'}
                                             backgroundColor={'rgb(239, 234, 229)'}/>
                </div>
                <div className="margin-right-15">
                    <LoadingPlaceholderBlock height={'18px'} width={'80px'} borderRadius={'3px'}
                                             backgroundColor={'rgb(239, 234, 229)'}/>
                </div>
            </div>
        </div>
    )
}

export {MetricsMessageListLoader}